import { styled } from 'styled-components';

export const Banner = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: ${({ theme }) => theme.spacing()}px ${({ theme }) => theme.spacing(1.5)}px;
  background-color: ${({ theme }) => theme.colors.mono.ui03};
`;

export const BannerText = styled.h1`
  margin: 0;
  font-size: ${({ theme }) => theme.font.size.md}rem;
  font-weight: ${({ theme }) => theme.font.default.weight.bold};
`;
